<template>
  <div ref="container">
    <div v-show="shouldDisplay('config')">
      <section class="title">
        <h3 class="configurator-title" v-html="title"></h3>
      </section>
      <section class="location checked-lists">
        <div class="selector">
          <div class="cloud" @click="toggle('cloud')">in der Cloud</div>
          <div
              class="toggle cloud-local"
              :class="{'active':mode === 'local'}"
              @click="toggle(mode==='cloud'?'local':'cloud')"
          ></div>
          <div class="local" @click="toggle('local')">lokal</div>
        </div>
        <div v-html="this[mode].description"></div>
      </section>
      <package
          v-for="packageItem in packages"
          :key="packageItem.key"
          :data="packageItem"
          :initial-enabled="Object.keys(packages).length ===1"
      />
      <section class="ranges">
        <div class="description" v-html="users_mandates_hint"></div>
        <range-slider :data="users" type="users"/>
        <range-slider :data="mandates" type="mandates"/>
      </section>
      <section class="price">
        <div class="price">
          <span><strong v-html="`${priceMonthly}/Mt.`"></strong></span>
          <span v-html="`${priceYearly}/Jahr`"></span>
        </div>
      </section>
      <section class="conditions">
        <div v-html="conditions" class="conditions-text"></div>
      </section>
      <section class="bottom-navigation">
        <span
            class="button"
            @click="changeView('summary')"
            :class="{'disabled':!enabledPackages.length}"
        ><span v-html="button_config_summary"></span></span>
        <p>oder</p>
        <span
            class="button"
            @click="changeView('form')"
            :class="{'disabled':!enabledPackages.length}"
        ><span v-html="button_config_form"></span></span>
      </section>
    </div>

    <div v-show="shouldDisplay('summary')">
      <div>
        <div class="calculation checked-lists">
          <table>
            <tr>
              <th colspan="2"><span class="summary-mode"><strong>PiNUS21</strong> {{
                  mode === 'cloud' ? 'in der Cloud' : 'lokal'
                }}</span></th>
            </tr>
            <tr v-for="packageItem in packages" :key="packageItem.key" v-if="packageItem.enabled">
              <th>
                <span class="package-title">{{ packageItem.title }}</span>
                <div class="description">
                  <div v-html="packageItem.description"></div>
                  <ul class="options">
                    <li
                        v-for="option in packageItem.options"
                        :key="option.key"
                        v-if="option.enabled"
                        v-html="option.title.overview"
                    >
                    </li>
                  </ul>
                </div>
              </th>
              <td><span class="package-price" v-html="`${formatPrice(packagePrice(packageItem))}/Mt.`"></span></td>
            </tr>
            <tr v-if="users.value > 1">
              <th><span class="addition-title">+ {{ users.value - 1 }} {{ rangeLabel('users') }}</span></th>
              <td><span class="addition-price" v-html="`${formatPrice(priceUsers)}/Mt.`"></span></td>
            </tr>
            <tr v-if="mandates.value > 1">
              <th><span class="addition-title">+ {{ mandates.value - 1 }} {{ rangeLabel('mandates') }}</span></th>
              <td><span class="addition-price" v-html="`${formatPrice(priceMandates)}/Mt.`"></span></td>
            </tr>
            <tr>
              <td colspan="2"><span v-html="`${priceYearly}/Jahr`" class="summary-price"></span><span
                  class="summary-price"><strong
                  v-html="`${priceMonthly}/Mt.`"></strong></span>
              </td>
            </tr>
          </table>
        </div>

        <div class="conditions-text" v-html="conditions"></div>
      </div>
      <PDFGenerator/>
      <div>
        <span
            class="button"
            @click="changeView('form')"
            :class="{'disabled':!enabledPackages.length}"
        ><span v-html="button_summary"></span></span>
      </div>
      <div class="backlink">
        <span @click="changeView('config')">zurück zur Konfiguration</span>
      </div>
    </div>

    <div v-show="shouldDisplay('form')">
      <div>
        <configurator-form></configurator-form>
        <div class="backlink">
          <span @click="changeView('summary')">zurück zur Zusammenfassung</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Package from "./Package";
import {formatPrice} from "../../Helpers";
import RangeSlider from "./RangeSlider";
import ConfiguratorForm from "./ConfiguratorForm";
import PDFGenerator from "./PDFGenerator.vue";

export default {
  name: "Configurator",
  props: {
    data: Object
  },
  data() {
    return {
      view: 'config',
      mode: 'cloud',
      title: '',
      conditions: '',
      users_mandates_hint: '',
      success_page: '',
      form_customernr_text: '',
      form_checkbox_label: '',
      form_checkbox_text: '',
      button_config_summary: '',
      button_config_form: '',
      button_summary: '',
      button_form: '',
      cloud: {},
      local: {},
      users: {},
      mandates: {},
      packages: {},
      partners: [],
    }
  },
  computed: {
    price() {
      let price = 0;
      price += this.priceUsers
      price += this.priceMandates

      for (let packageItem of this.enabledPackages) {
        price += this.packagePrice(packageItem)
      }

      return price;
    },
    priceUsers() {
      return this.users.price[this.mode] * (this.users.value - 1);
    },
    priceMandates() {
      return this.mandates.price[this.mode] * (this.mandates.value - 1);
    },
    priceMonthly() {
      return formatPrice(this.price);
    },
    priceYearly() {
      return formatPrice(this.price * 12);
    },
    enabledPackages() {
      return Object.values(this.packages).filter(packageItem => packageItem.enabled);
    }
  },
  methods: {
    formatPrice: formatPrice,
    shouldDisplay(view) {
      return this.view === view;
    },
    updateRangeData(type, value) {
      this[type].value = value;
    },
    togglePackage(key) {
      this.packages[key].enabled = !this.packages[key].enabled;
    },
    toggleOption(key, packageKey) {
      this.packages[packageKey].options[key].enabled = !this.packages[packageKey].options[key].enabled;
    },
    toggle(location) {
      // TODO[mr]: disabled because local is not ready yet (09.05.22 mr)
      return;

      if (location && location === this.mode) {
        return;
      }
      if (location) {
        this.mode = location;
      } else {
        this.mode = this.mode === 'cloud' ? 'local' : 'cloud';
      }
    },
    packagePrice(packageItem) {
      let price = 0;

      if (!packageItem.enabled) {
        return price;
      }
      price += packageItem[this.mode].price;

      for (let option of Object.values(packageItem.options)) {
        if (!option.enabled) {
          continue;
        }
        price += option[this.mode].price;
      }
      return price;
    },
    rangeLabel(type) {
      return parseInt(this[type].value) === 1 ? this[type].labels.singular : this[type].labels.plural;
    },
    changeView(view) {
      this.view = view;
      window.setTimeout(
          () => {
            window.scrollTo({
              top: this.$refs.container.offsetTop - 10,
              behavior: 'smooth'
            })
          },
          0
      );
    },
    sendMail(data) {
      const formData = new FormData();
      for (const [key, value] of Object.entries(data)) {
        formData.append(key, value);
      }

      formData.append('mode', this.mode);
      formData.append('users', this.users.value);
      formData.append('mandates', this.mandates.value);

      for (const packageItem of Object.values(this.packages)) {
        const packageEnabled = packageItem.enabled;
        formData.append(packageItem.key, packageEnabled);

        for (const option of Object.values(packageItem.options)) {
          const optionEnabled = !packageEnabled ? false : option.enabled;
          formData.append(option.key, optionEnabled);
        }
      }


      fetch('/configurator-mailer.php', {
        method: 'post',
        body: formData
      })
          .then(response => response.json())
          .then(data => {
            if (data.success === true) {
              this.redirectSuccess();
            }
          })
          .catch()
    },
    redirectSuccess() {
      window.location = this.data.general.success_page;
    }
  },
  created() {
    this.$root.$on('packageToggled', this.togglePackage)
    this.$root.$on('optionToggled', this.toggleOption)
    this.$root.$on('rangeSliderChanged', this.updateRangeData)
    this.$root.$on('formSubmitted', this.sendMail);

    for (const [key, value] of Object.entries(this.data.general)) {
      this[key] = value;
    }

    this.packages = this.data.packages;
    this.partners = this.data.partners;
  },
  components: {PDFGenerator, Package, RangeSlider, ConfiguratorForm}
}
</script>
